export default __webpack_public_path__ + "static/media/got_you.027b216e.jpg";